import mixpanel from 'mixpanel-browser'
import moment from 'moment'
import TagManager from 'react-gtm-module'
import {
  CLOUDINARY_API_KEY,
  CLOUDINARY_NAME,
} from '../../../constants/images/cloudinary'
import {
  USER_SMALL_PARAMS,
  USER_MEDIUM_PARAMS,
} from '../../../constants/images/sizesAndQuality'
import cloudinary from 'cloudinary-core'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  //upload_preset : CLOUDINARY_VEHICLE_PRESET,
  api_key: CLOUDINARY_API_KEY,
})
export const trackBikeProfilePageView = (params) => {
  let cleanParams = prepBikeData(params)

  cleanParams['motorcycle_image_large'] = cl.url(
    params.bike_images[0].bike_image_cloudinary_public_id,
    {
      gravity: 'center',
      height: 600,
      width: 900,
      crop: 'fill',
      format: 'jpg',
      quality: 80,
    }
  )

  cleanParams['motorcycle_image_small'] = cl.url(
    params.bike_images[0].bike_image_cloudinary_public_id,
    {
      gravity: 'center',
      height: 250,
      width: 425,
      crop: 'fill',
      format: 'jpg',
      quality: 80,
    }
  )

  cleanParams['owner_avatar_large'] = cl.url(
    params.bike_owner_avatar_cloudinary_public_id,
    USER_MEDIUM_PARAMS
  )

  cleanParams['owner_avatar_small'] = cl.url(
    params.bike_owner_avatar_cloudinary_public_id,
    USER_SMALL_PARAMS
  )

  mixpanel.track('Page View - Motorcycle Profile', cleanParams)
}

export const trackBikeProfileBrowsedPhotos = () => {
  mixpanel.track('Motorcycle Profile - Browsed Photos')
}

export const trackBikeProfileSelectedDates = () => {
  mixpanel.track('Motorcycle Profile - Selected Dates')
}

export const trackBikeProfilePricing = (params, pricingData, bikeData) => {
  let cleanParams = prepBikeData(bikeData)
  cleanParams['start_date'] = moment(params.start_at).toISOString()
  cleanParams['end_date'] = moment(params.end_at).toISOString()
  cleanParams['trip_days'] = moment(params.end_at).diff(
    moment(params.start_at),
    'days'
  )
  cleanParams['service_fee'] =
    pricingData.pricing.totals.service_fee_scheduled_total
      .service_fee_scheduled_total_cents / 100
  cleanParams['book_now_total'] =
    pricingData.pricing.line_items[0].amount_cents / 100
  cleanParams['motorcycle_image_large'] = cl.url(
    bikeData.bike_images[0].bike_image_cloudinary_public_id,
    {
      gravity: 'center',
      height: 600,
      width: 900,
      crop: 'fill',
      format: 'jpg',
      quality: 80,
    }
  )

  cleanParams['motorcycle_image_small'] = cl.url(
    bikeData.bike_images[0].bike_image_cloudinary_public_id,
    {
      gravity: 'center',
      height: 250,
      width: 425,
      crop: 'fill',
      format: 'jpg',
      quality: 80,
    }
  )

  cleanParams['owner_avatar_large'] = cl.url(
    bikeData.bike_owner_avatar_cloudinary_public_id,
    USER_MEDIUM_PARAMS
  )

  cleanParams['owner_avatar_small'] = cl.url(
    bikeData.bike_owner_avatar_cloudinary_public_id,
    USER_SMALL_PARAMS
  )

  //const object3 = {...cleanParams, ...bikeData }

  mixpanel.track('Motorcycle Profile - Pricing', cleanParams)
}

export const trackBikeBookingSuccess = (
  params,
  pricingData,
  reservationData,
  bikeData,
  callBack,
  resID
) => {
  let cleanParams = prepBikeData(bikeData)

  cleanParams['start_date'] = moment(params.start_at).toISOString()
  cleanParams['end_date'] = moment(params.end_at).toISOString()
  cleanParams['trip_days'] = moment(params.end_at).diff(
    moment(params.start_at),
    'days'
  )
  cleanParams['start_day_week'] = moment(params.start_at)
    .tz(bikeData.bike_timezone)
    .format('dddd')
  cleanParams['end_day_week'] = moment(params.start_end)
    .tz(bikeData.bike_timezone)
    .format('dddd')
  cleanParams['start_time'] = moment(params.start_at)
    .tz(bikeData.bike_timezone)
    .format('h:mm a')
  cleanParams['end_time'] = moment(params.start_end)
    .tz(bikeData.bike_timezone)
    .format('h:mm a')

  cleanParams['service_fee'] =
    pricingData.totals.service_fee_scheduled_total
      .service_fee_scheduled_total_cents / 100

  cleanParams['book_now_total'] = pricingData.line_items[0].amount_cents / 100

  cleanParams['motorcycle_image_large'] = cl.url(
    bikeData.bike_images[0].bike_image_cloudinary_public_id,
    {
      gravity: 'center',
      height: 600,
      width: 900,
      crop: 'fill',
      format: 'jpg',
      quality: 80,
    }
  )

  cleanParams['motorcycle_image_small'] = cl.url(
    bikeData.bike_images[0].bike_image_cloudinary_public_id,
    {
      gravity: 'center',
      height: 250,
      width: 425,
      crop: 'fill',
      format: 'jpg',
      quality: 80,
    }
  )

  cleanParams['owner_avatar_large'] = cl.url(
    bikeData.bike_owner_avatar_cloudinary_public_id,
    USER_MEDIUM_PARAMS
  )

  cleanParams['owner_avatar_small'] = cl.url(
    bikeData.bike_owner_avatar_cloudinary_public_id,
    USER_SMALL_PARAMS
  )

  //const object3 = {...cleanParams, ...bikeData }

  cleanParams['duplicate_booking'] = reservationData.duplicate

  if (!reservationData.duplicate) {
    TagManager.dataLayer({
      dataLayer: {
        event: 'fireTREvent',
        trEventCategory: 'Conversion',
        trEventAction: 'Success',
        trEventLabel: 'Booking Created',
        trEventValue: pricingData.line_items[0].amount_cents / 100,
        trEventResID: 'bc-' + resID,
      },
    })
  }

  let mixpanelTrackDescription = 'Motorcycle Reserve Now (Create Booking)'

  ///if(reservationData.duplicate) {
  // let mixpanelTrackDescription = 'Motorcycle Book Now Duplicate (Create Booking)'
  //}

  mixpanel.people.set({
    last_booking_created_motorcycle_description: bikeData.bike_description,
    last_booking_created_motorcycle_url:
      'https://www.twistedroad.com' + bikeData.bike_url,
    last_booking_created_motorcycle_title:
      bikeData.bike_year + ' ' + bikeData.bike_make + ' ' + bikeData.bike_model,
    last_booking_created_motorcycle_nickname: bikeData.bike_nickname,
    last_booking_created_motorcycle_region_abbr:
      bikeData.bike_location.location_region_abbr,
    last_booking_created_motorcycle_region:
      bikeData.bike_location.location_region,
    last_booking_created_motorcycle_city: bikeData.bike_location.location_city,
    last_booking_created_motorcycle_country:
      bikeData.bike_location.location_country,
    last_booking_created_motorcycle_country_abbr:
      bikeData.bike_location.location_country_abbr,
    last_booking_created_daily_price: bikeData.bike_daily_price_cents / 100,
    last_booking_created_motorcycle_average_rating:
      bikeData.bike_overall_rating,
    last_booking_created_motorcycle_reviews_count: bikeData.bike_review_count,
    last_booking_created_motorcycle_image_large: cl.url(
      bikeData.bike_images[0].bike_image_cloudinary_public_id,
      {
        gravity: 'center',
        height: 600,
        width: 900,
        crop: 'fill',
        format: 'jpg',
        quality: 80,
      }
    ),

    last_booking_created_motorcycle_image_small: cl.url(
      bikeData.bike_images[0].bike_image_cloudinary_public_id,
      {
        gravity: 'center',
        height: 250,
        width: 425,
        crop: 'fill',
        format: 'jpg',
        quality: 80,
      }
    ),
  })

  mixpanel.track(mixpanelTrackDescription, cleanParams, {}, callBack)
}

export const trackBookNowSuccessAttempt = (
  desc,
  bikeId,
  requestUuid,
  requestPrettyId
) => {
  mixpanel.track('Motorcycle Reserve Now (Create Booking) SUCCESS', {
    message: desc,
    motorcycle_id: bikeId,
    request_uuid: requestUuid,
    request_pretty_id: requestPrettyId,
  })
}

export const trackBookNowFailedAttempt = (desc, params) => {
  mixpanel.track('Motorcycle Reserve Now (Create Booking) ERROR', {
    error_type: desc,
    motorcycle_id: params.motorcycle_id,
    raw_error_data: params.raw_error_data,
  })
}

export const prepBikeData = (bikeData) => {
  return {
    motorcycle_id_number: bikeData.bike_id,
    motorcycle_uuid: bikeData.bike_uuid_id,
    motorcycle_pretty_id: bikeData.bike_pretty_id,
    motorcycle_year: bikeData.bike_year,
    motorcycle_model: bikeData.bike_model,
    motorcycle_make: bikeData.bike_make,
    motorcycle_region_abbr: bikeData.bike_location.location_region_abbr,
    motorcycle_region: bikeData.bike_location.location_region,
    motorcycle_city: bikeData.bike_location.location_city,
    motorcycle_country: bikeData.bike_location.location_country,
    motorcycle_country_abbr: bikeData.bike_location.location_country_abbr,
    motorcycle_category: bikeData.bike_category,
    motorcycle_nickname: bikeData.bike_nickname,
    motorcycle_weight_lbs: bikeData.bike_weight,
    motorcycle_engine_cc: bikeData.bike_engine,
    motorcycle_seat_height_in: bikeData.bike_seat_height,
    motorcycle_description: bikeData.bike_description,
    motorcycle_odometer_miles: bikeData.bike_odometer,
    motorcycle_fuel_tank_capacity_gallons: bikeData.bike_fueltank,
    motorcycle_distance_refuel_miles: bikeData.bike_distance_refuel,
    daily_price: bikeData.bike_daily_price_cents / 100,
    daily_price_currency: bikeData.bike_daily_price_currency,
    motorcycle_average_rating: bikeData.bike_overall_rating,
    motorcycle_reviews_count: bikeData.bike_review_count,
    owner_first_name: bikeData.bike_owner_first_name,
    owner_average_rating: bikeData.bike_owner_rating,
    owner_reviews_count: bikeData.bike_owner_review_count,
    owner_pretty_id: bikeData.bike_owner_id,
    images_count: bikeData.bike_images.length,
    featured_motorcycle: bikeData.featured,
    motorcycle_trips_taken: bikeData.trips_taken,
    motorcycle_listed_on: bikeData.listed_at,
    has_multiday_discount: bikeData.has_multiday_discount,
  }
}

export const trackNewBikeIsListedForSale = (
  userId,
  year,
  make,
  model,
  plate
) => {
  mixpanel.track(
    year +
      ' ' +
      make +
      ' ' +
      model +
      ' (plate #:' +
      ' ' +
      plate +
      ') is marked as for sale by user id: ' +
      userId
  )
}

export const trackNewBikeContactAboutASale = (
  userId,
  year,
  make,
  model,
  plate
) => {
  mixpanel.track(
    'Owner (' +
      userId +
      ') of ' +
      ' ' +
      year +
      ' ' +
      make +
      ' ' +
      model +
      ' (plate #:' +
      ' ' +
      plate +
      ') would like to be contacted about selling this bike.'
  )
}

export const trackNewBikeForSalePrice = (price, year, make, model, plate) => {
  mixpanel.track(
    year +
      ' ' +
      make +
      ' ' +
      model +
      ' (plate #:' +
      ' ' +
      plate +
      ') has changed its price to $' +
      price
  )
}

export const trackBikeIsListedForSale = (bikeID) => {
  mixpanel.track('Bike was marked as for sale (edit section)', {
    bike_id: bikeID,
  })
}

export const trackBikeNoLongerForSale = (bikeID) => {
  mixpanel.track('Bike is no longer marked as for sale (edit section)', {
    bike_id: bikeID,
  })
}

export const trackContactMeBikeIsListedForSale = (bikeID) => {
  mixpanel.track(
    'Owner changed the contact me status of ' +
      bikeID +
      ' and wants to be contacted.',
    {
      bike_id: bikeID,
    }
  )
}

export const trackDoNotContactMeBikeIsListedForSale = (bikeID) => {
  mixpanel.track(
    'Owner changed the contact me status of ' +
      bikeID +
      ' and no longer wants to be contacted.',
    {
      bike_id: bikeID,
    }
  )
}
